import React from "react";
import { VolumeUp, VolumeOff } from "@mui/icons-material";

/**
 * Get icon for volume/mute widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getVolumeMuteIcon = (widget = null) => {
  const iconProps = {
    style: { fontSize: "1.5rem", paddingBottom: "2px" },
  };

  // Check widget state to show muted/unmuted icon
  if (widget?.items?.$w1?.value === "muted") {
    return <VolumeOff {...iconProps} />;
  }
  return <VolumeUp {...iconProps} />;
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getVolumeMutePatterns = () => {
  return ["basic.device.audioVolumeMute"];
};
